var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-layout",class:[
    {
      'section-layout--large': _vm.large,
      'section-layout--imaged': _vm.bgWithImage,
      'section-layout--call-to-action': _vm.isCallToAction,
      'section-layout--with-main-banner': _vm.applyMainBannerBg,
      'feedback-form-section': _vm.isFeedbackForm,
      'section-layout--halved-content': _vm.halvedContent,
    },
    _vm.bgThemeClass
  ]},[(!_vm.isCallToAction)?_c('header',{staticClass:"section-layout__header"},[(_vm.steps)?_c('StepCounterList',{staticClass:"section-layout__steps",attrs:{"steps":_vm.steps,"current-step":_vm.currentStep}}):_vm._e(),(_vm.title.length)?_c('h2',{staticClass:"section-layout__title",class:_vm.titleBottomMarginClass},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.title.length)?_c('div',{staticClass:"section-layout__subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()],1):_vm._e(),_c('div',{staticClass:"section-layout__wrapper"},[_c('div',{staticClass:"section-layout__content"},[_vm._t("default")],2),(_vm.$slots['aside-content'])?_c('div',{staticClass:"section-layout__aside"},[_vm._t("aside-content")],2):_vm._e()]),_vm._t("actions")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }